module.exports = __webpack_public_path__ + "images/tracking-nav-icon-343f3207.svg";